export const getCurrentMonthRangeInLocalTime = (): {
	startDate: Date;
	endDate: Date;
} => {
	// Get the current date in the user's local time
	const now = new Date();

	// Get the start of the current month (midnight on the 1st day)
	const startDate = new Date(
		now.getFullYear(),
		now.getMonth(),
		1,
		0,
		0,
		0,
		0,
	);

	// Get the end of the current month (23:59:59 on the last day)
	const endDate = new Date(
		now.getFullYear(),
		now.getMonth() + 1,
		0,
		23,
		59,
		59,
		999,
	);

	return { startDate, endDate };
};
